const productIds = { WaterMeter: "438", Sentree: "7352", Hubbie: "8263", SumpPit: "6299" }
export default productIds;